// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FulfillmentOrder } from '@/fulfillment/api/types';
import { updateFulfillmentOrder } from '@/fulfillment/api/update-fulfillment-order';
import {
  fulfillmentDetailQueryKey,
  fulfillmentsQueryKey,
} from '@/fulfillment/query-keys';
import { OrderNotesControl } from '@/order/components/order-notes-control';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
  fulfillment: Pick<FulfillmentOrder, 'key' | 'orderNotes' | 'status'>;
  isOriginThirdParty?: boolean;
}

export function FulfillmentNotesControl(props: Props) {
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: fulfillmentDetailQueryKey(props.fulfillment.key),
    });
    queryClient.invalidateQueries({ queryKey: fulfillmentsQueryKey });
  };

  // Disable editing if:
  // 1. Origin is 3PL and status is not draft (already sent to 3PL)
  const is3PLLocked =
    props.isOriginThirdParty === true && props.fulfillment.status !== 'DRAFT';

  const tooltipTitle = is3PLLocked
    ? 'This has already been sent to your 3PL provider and can no longer be edited'
    : '';

  return (
    <OrderNotesControl
      orderNotes={props.fulfillment.orderNotes}
      updateNotes={(orderNotes) =>
        updateFulfillmentOrder(props.fulfillment.key, { orderNotes })
      }
      onSuccess={handleSuccess}
      isDisabled={is3PLLocked}
      tooltipTitle={tooltipTitle}
    />
  );
}
